import { render, staticRenderFns } from "./StudentClassCard.vue?vue&type=template&id=1c58c004&scoped=true&"
import script from "./StudentClassCard.vue?vue&type=script&lang=js&"
export * from "./StudentClassCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentClassCard.vue?vue&type=style&index=0&id=1c58c004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58c004",
  null
  
)

export default component.exports